"use strict";
/*!
 * Buttplug JS Source Code File - Visit https://buttplug.io for more info about
 * the project. Licensed under the BSD 3-Clause license. See LICENSE file in the
 * project root for full license information.
 *
 * @copyright Copyright (c) Nonpolynomial Labs LLC. All rights reserved.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtplugDeviceProtocol = void 0;
const events_1 = require("events");
const Logging_1 = require("../core/Logging");
const Exceptions_1 = require("../core/Exceptions");
class ButtplugDeviceProtocol extends events_1.EventEmitter {
    constructor(aName, aDevice) {
        super();
        // It would be really nice to store a map of types here, but the only way I
        // can figure out to do that is using the constructor for
        // ButtplugDeviceMessage classes, which always resolves to Function. This is
        // basically a useless type in Typescript, but it does the job for now. Just
        // means we have to turn off type complaining.
        //
        // tslint:disable-next-line:ban-types
        this.MsgFuncs = 
        // tslint:disable-next-line:ban-types
        new Map();
        this._logger = Logging_1.ButtplugLogger.Logger;
        this.ParseMessage = (aMsg) => __awaiter(this, void 0, void 0, function* () {
            if (!this.MsgFuncs.has(aMsg.Type)) {
                throw new Exceptions_1.ButtplugMessageException(`${this._name} cannot handle message of type ${aMsg.Type.name}`, aMsg.Id);
            }
            // Non-null assurance in the middle of functions looks weird.
            return this.MsgFuncs.get(aMsg.Type)(aMsg);
        });
        this._name = aName;
        this._device = aDevice;
    }
    get Name() {
        return this._name;
    }
    // tslint:disable-next-line:ban-types
    get AllowedMessageTypes() {
        return Array.from(this.MsgFuncs.keys());
    }
    Initialize() {
        return __awaiter(this, void 0, void 0, function* () {
            return Promise.resolve();
        });
    }
}
exports.ButtplugDeviceProtocol = ButtplugDeviceProtocol;
//# sourceMappingURL=ButtplugDeviceProtocol.js.map